<template>
    <div>
      <national-trademark-note-type-list></national-trademark-note-type-list>
    </div>
  </template>
  
  <script>
  
  export default {
  }
  </script>
  
  
  